import { Component, Inject, InjectionToken, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// models
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';

// services
import { AddProductsService } from '../../../services/add-products.service';

import { SHARED_MODULES } from '../../../../shared.';
import { LoaderComponent } from '../../loader/loader.component';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

@Component({
    selector: 'app-product-list-add-button-dtype',
    templateUrl: './product-list-add-button-dtype.component.html',
	imports: [SHARED_MODULES, LoaderComponent, PhIconWrapperComponent],
    standalone: true
})
export class ProductListAddButtonDtypeComponent implements OnDestroy {

	private _subscriptions: Array<Subscription> = [];

	showLoader: boolean = false;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<void>,
		private addProductsFiltersService: AddProductsService
	) {
		this._subscriptions.push(
			this.addProductsFiltersService.addedEndSubject.subscribe((id: number) => {
				if (this.elementInjected.key === id) this.showLoader = false;
			})
		);
	}

	addProduct(): void {
		this.showLoader = true;
		this.addProductsFiltersService.addProductsSubject.next(this.elementInjected.key as number);
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}
}
